module.exports = __webpack_public_path__ + "static/sec5-bg-sm-579096c1acaed10b840e8e37079cad9b.jpg";